module.exports = __webpack_public_path__ + "images/green-nature-5-6da9749ef8072e09179aee9facbf8616.jpg";